var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.column.customFunction)?_c('span',{class:_vm.pClass},[_vm._v(" "+_vm._s(_vm.column.customFunction(_vm.data))+" ")]):_c('span',{class:_vm.pClass},[_vm._v(" "+_vm._s(_vm.data[_vm.column.field])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }